module.exports = __webpack_public_path__ + "img/BOND.b0f3513f.png";